import { render, staticRenderFns } from "./WaitingDiscountModal.vue?vue&type=template&id=5ea1749b&scoped=true&"
import script from "./WaitingDiscountModal.vue?vue&type=script&lang=ts&"
export * from "./WaitingDiscountModal.vue?vue&type=script&lang=ts&"
import style0 from "./WaitingDiscountModal.vue?vue&type=style&index=0&id=5ea1749b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea1749b",
  null
  
)

export default component.exports